import { Application, Nullable } from '@bybeam/platform-types';
import React, { useContext } from 'react';

export const ApplicationContext = React.createContext<Nullable<Application>>(undefined);

export default function useApplication(): Nullable<Application> {
  return useContext(ApplicationContext);
}
